import { useContext, useMemo } from 'react';

import type { GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

import {
  GridStatusBar,
  type GridStatusBarParams,
  WithLocalStorage,
} from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';
import { PrimaryContext } from '@/services';
import type { ShipmentRecipient } from '@/services/shipping/types';
import { useContextMenu } from '@/utils/context-menu';

import { recipientColumnDefs } from '../../utils/columnDefs';

type ShipmentRecipientGridProps = {
  recipients: ShipmentRecipient[] | null | undefined;
};

export const ShipmentRecipientGrid = ({
  recipients,
}: ShipmentRecipientGridProps) => {
  const defaultGridOptions = useDefaultGridOptions();
  const { themeMode } = useContext(PrimaryContext);
  const { getContextMenuItems } = useContextMenu({ idKey: 'id' });

  const statusBar = useMemo<NonNullable<GridOptions['statusBar']>>(
    () => ({
      statusPanels: [
        {
          statusPanel: GridStatusBar,
          statusPanelParams: {
            entityLabel: 'recipients',
          } satisfies GridStatusBarParams,
          align: 'left',
        },
      ],
    }),
    [],
  );

  return (
    <div className="shipment__grid ag-grid-height-300">
      <WithLocalStorage storageKey="shipment-recipient-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}`}
          defaultColDef={defaultColDef}
          rowData={recipients}
          columnDefs={recipientColumnDefs}
          getContextMenuItems={getContextMenuItems}
          rowSelection="multiple"
          statusBar={statusBar}
        />
      </WithLocalStorage>
    </div>
  );
};
